/**
 * package: com.inq.flash.client.control
 * class: ApplicationController
 * root Object
 * @constructor
 */
com.inq.flash.client.control.ApplicationController = function() {
	if(null == com.inq.flash.client.control.ApplicationController.applicationController) com.inq.flash.client.control.ApplicationController.applicationController = this;
	this.chatRouterListen = false;
	this.firstMessageSent = this.persistentReconnect = false;
	this.openerMessageQueue = new Array();
	this.authorizedOnce = false;/*  REQ-1729*/
	this.chatAccepted = false;
	this.bSendClickStreamData = false;
	this.messageQueue = new Array();
	this.flagChatInQueue = false;
	this._updateUsername = false;

	/* create the framework object */
	haxe.Log.trace("create FlashMessagingFramework",{ fileName : "ApplicationController.hx", lineNumber : 107, className : "com.inq.flash.client.control.ApplicationController", methodName : "new"});
	this.framework = new com.inq.flash.messagingframework.FlashMessagingFramework(this);
	haxe.Log.trace("created FlashMessagingFramework",{ fileName : "ApplicationController.hx", lineNumber : 109, className : "com.inq.flash.client.control.ApplicationController", methodName : "new"});

	window["com"] = com;
	window["com"]["inq"] = com.inq;
	window["com"]["inq"]["getOpenerMessageQueue"] = $bind(this,this.getOpenerMessageQueue);
	window["com"]["inq"]["getMessageQueue"] = $bind(this,this.getMessageQueue);

	this.msgcntAtEntry = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0);

	if(this.chat == null) this.chat = new com.inq.flash.client.data.Chat();
};
$hxClasses.registerClass(com.inq.flash.client.control.ApplicationController,'com.inq.flash.client.control.ApplicationController');

com.inq.flash.client.control.ApplicationController.isSkipRestoreMsgOnce = false;

com.inq.flash.client.control.ApplicationController.prototype.registerMessageHandlers = function() {
	/*
	 * register all handlers.
	 * Order is important here, specific handlers should be before common.
	 * Example, chat.denied.reconnect should be before chat.denied
	 */
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatAutomatonDataMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatroomOwnerTransferResponseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatroomTransferResponse());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatroomMemberLostMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ErrorHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatSystemMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.NeedWaitHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.TypingActivityHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CommandMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatLineMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.PersistentActiveHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatWebCallMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatVideoPlayerStatusMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler());

	this.skinControl = com.inq.flash.client.chatskins.SkinControl;
};

/**
 * getChat
 * getter of chat
 *
 * *
 * --------------------- *
 *
 * $type TFun([],TInst(com.inq.flash.client.data.Chat,[]))
 * public function getChat():Chat
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {com.inq.flash.client.data.Chat} -  current chat instance.
 */
com.inq.flash.client.control.ApplicationController.prototype.getChat = function() {
	return this.chat;
};

/**
 * sendDTEvent
 * Send chat.automaton_response msg
 *
 * $type TFun([{ name => eventName, t => TInst(String,[]), opt => false },{ name => data, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function sendDTEvent(eventName:String, data:Dynamic):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  eventName -  event name
 * @param {null}  data -  parameters from chat.automaton_request msg
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendDTEvent = function(eventName,data) {
	/** @type {com.inq.flash.client.data.ChatAutomatonResponseMessage} */
	var msg = new com.inq.flash.client.data.ChatAutomatonResponseMessage(this.chat,eventName,data);
	/** @type {?string} */
	var selectedLinkName = null;
	if (data.selectedLinkName) {
		selectedLinkName = data.selectedLinkName;
	}

	this.skinControl.modifyDTFields(data.divId, selectedLinkName);
	this.sendMessageOrQueue(msg);
	this.skinControl.stopOpenerScript();


	com.inq.flash.client.control.Incrementality.onInteracted();
	com.inq.flash.client.control.Incrementality.onCustomerMsg();
};


/**
 * sendInputState
 * Send chat."chat.setting" msg
 *
 * This sends a request to the CR for attribute change for an element in CI !!!
 * We do this to persist the attribute change.
 * When this message is played back from the queue, it is applied.
 *
 * So any attributes that are to be persisted from page-to-page will be via this message.
 *
 * $type TFun([{ name => itemName, t => TInst(String,[]), opt => false },{ name => attributeName, t => TInst(String,[]), opt => false },{ name => state, t => TInst(String,[]), opt => false },{ name => changeNow, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public function sendInputState(itemName:String, attributeName:String, state:String, changeNow:Bool)
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  itemName - of the item
 * @param {string}  attributeName -  name of the attribute that will be changed
 * @param {string}  state - the new value of the attribute
 * @param {boolean}  changeNow - whether to update the attribute now, without waiting for CR to send it back (via /chatrouter/chat/getMessage.js)
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendInputState = function(itemName,attributeName,state,changeNow) {
	if(changeNow) com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setAttribute(itemName,attributeName,state);
	/** @type {com.inq.flash.client.data.ChatAutomatonElementSetMessage} */
	var msg = new com.inq.flash.client.data.ChatAutomatonElementSetMessage(this.chat,itemName,attributeName,state);
	this.sendMessageOrQueue(msg);
	/* Increment the active count for this message */
	com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.incrementOutstandingCount();
};


/**
 * sendCoBrowseMessage
 *
 * $type TFun([{ name => messageString, t => TInst(String,[]), opt => false },{ name => eventType, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function sendCoBrowseMessage(messageString:String, eventType:String )
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  messageString
 * @param {string}  eventType
 * @param {boolean} highlightEnabled
 * @param {boolean} showMinimizeRestore
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendCoBrowseMessage = function(messageString,eventType,highlightEnabled,showMinimizeRestore) {
	var message = new com.inq.flash.client.data.ChatCommunicationCobrowseMessage(this.chat,messageString);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT,eventType);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"-1");
	if (highlightEnabled && eventType == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_HIGHLIGHT_ENABLED, "1");
	}
	/**
	 * @RTDEV-15837: Agent Minimize/Restore link (Mobile Cobrowse)
	 *   Setting the property to either enable or disable the link to "Minimize or Restore  Chat" on AI (CoBrowse) based on on AI (CoBrowse) only
     *   when the flag "showMinimizeRestore" is true and when the customer accepts the cobrowse invite (both shared and non shared)
	 */
	if (showMinimizeRestore &&
		(eventType == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT || eventType == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT_SHARE)) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_MINIMIZE_RESTORE_ENABLED, "1");
	}
	this.sendText(message);
};

com.inq.flash.client.control.ApplicationController.prototype.sendVideoMessage = function(messageString, eventType) {
	/** @type {com.inq.flash.client.data.ChatActivityMessage} */
	var message = new com.inq.flash.client.data.ChatActivityMessage(this.chat, eventType);
    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_DISPLAY_TEXT, messageString);
    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"-1");
    this.sendText(message);
};
/**
 * sending fileupload url to agent
 * @param {string} messageString
 * @param {string} delSetting
 */
com.inq.flash.client.control.ApplicationController.prototype.sendFileUploadMessage = function(messageString, delSetting, engagedCallback) {
	var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	var message = new com.inq.flash.client.data.ChatCommunicationFileUploadMessage(this.chat, messageString);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_FILE_DELETE_SETTING, delSetting);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, "-1");
	if (msgcnt > 0) {
		this.sendMessageOrQueue(message);
	} else if (engagedCallback && !this.isChatInProgress() && !this.framework.isConnected()) {
		this.engageAndSendMessage(message, engagedCallback, "#EmptyAnswer");
	}
};

/**
 * sending VideoPlayer event to agent
 * @param messageString
 * @param {string} url
 * @param {string} action
 */
com.inq.flash.client.control.ApplicationController.prototype.sendVideoStatusMessage = function(messageString, url, action) {
	var message = new com.inq.flash.client.data.ChatVideoPlayerStatusMessage(this.chat, messageString);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_VIDEO_URL, url);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_VIDEO_ACTION, action);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, "-1");
	this.sendMessageOrQueue(message);
};
/**
 * sending webcall message to agent
 * @param messageString
 * @param action
 */

com.inq.flash.client.control.ApplicationController.prototype.sendWebCallMessage = function(messageString,action) {
	var message = new com.inq.flash.client.data.ChatCommunicationWebCallMessage(this.chat, messageString);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_WEBCALL_ACTION, action);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, "-1");
	this.sendMessageOrQueue(message);
};

com.inq.flash.client.control.ApplicationController.prototype.sendWebCallEndMessage = function(messageString,isCusEnd, isAbandoned) {
	var wMgr =  com.inq.flash.client.control.WebRTCMgr;
	var mf = com.inq.flash.client.data.MessageFields;
	var message = new com.inq.flash.client.data.ChatCommunicationWebCallMessage(this.chat, messageString);
	message.addProperty(mf.KEY_WEBCALL_ACTION, isAbandoned ? wMgr.WEBCALL_LEFT
		: wMgr.WEBCALL_ENDED);
	message.addProperty(mf.KEY_CALL_TERMINATED, isCusEnd ? "1" : "0");
	message.addProperty(mf.KEY_LINE_NR, "-1");
	this.sendMessageOrQueue(message);
};

/**
 * Send CoBrowse message quietly.
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}   messageString
 * @param {string}   eventType
 * @param {string}  testResult  - test result
 * @param {boolean} highlightEnabled
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendCoBrowseMessageQuietly = function(messageString, eventType, testResult, highlightEnabled, agentId) {
    var message = new com.inq.flash.client.data.ChatCommunicationCobrowseMessage(this.chat, messageString);
    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT, eventType);
    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, "-1");
    if (testResult === com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_SUCCESS ||
		testResult === com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_FAILURE) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT, testResult);
	}
    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_CUSTOMER_QUIET, "true");
	message.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_ADVANCED_AGENT_ID, agentId);
	if (highlightEnabled && eventType == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_HIGHLIGHT_ENABLED, "1");
	}
    this.sendText(message);
};

/**
 * updateFormFields
 *
 * $type TFun([{ name => formData, t => TInst(String,[]), opt => false },{ name => formName, t => TInst(String,[]), opt => false },{ name => formId, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function updateFormFields(formData:String, formName:String, formId:String )
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  formData
 * @param {string}  formName
 * @param {string}  formId
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.updateFormFields = function(formData,formName,formId) {
	this.skinControl.updateFormFields(formData,formName,formId);
};


/**
 * submitForm
 *
 * $type TFun([{ name => formName, t => TInst(String,[]), opt => false },{ name => formId, t => TInst(String,[]), opt => false },{ name => formString, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function submitForm( formName:String, formId:String, formString:String ):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  formName
 * @param {string}  formId
 * @param {string}  formString
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.submitForm = function(formName,formId,formString,displayMessage) {
	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat,displayMessage);
	message.addProperty(com.inq.flash.client.data.MessageFields.FORM_DATA,formString);
	message.addProperty(com.inq.flash.client.data.MessageFields.FORM_NAME,formName);
	message.addProperty(com.inq.flash.client.data.MessageFields.FORM_ID,formId);

	this.sendText(message);
};


/**
 * isFirstMessageSent
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function isFirstMessageSent():Bool
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isFirstMessageSent = function() {
	return this.firstMessageSent;
};


/**
 * customerClosesPopup
 * Request from customer to close the chat
 *
 * Request "chat.exit" message sends only to inform Chat Router about closing the chat interface,
 * and response on this request is no longer handled.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function customerClosesPopup():Bool
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.customerClosesPopup = function() {
	this.waitingToExitChat = true;
	try {
		var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0);
		if (this.framework.isConnected() || this.wasConnected || msgcnt != 0) {
			if (!this.authorizedOnce && this.msgcntAtEntry == 0) {
				/* If the communication was never authorized, then just close the connection and return */
				this.shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CUSTOMER_CLOSED); /* REQ-1729)*/
				/* This shall not result in a "chat.exit" message */
				return false;
			}
			return true;
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {

			haxe.Log.trace("customerClosesPopup: Warning:" + Std.string(e),{ fileName : "ApplicationController.hx", lineNumber : 910, className : "com.inq.flash.client.control.ApplicationController", methodName : "customerClosesPopup"});
		} else throw(e);
	}
	return false;
};


/**
 *
 * send "chat.exit" message
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {?function} customerClosedChat - see the SkinControl.customerClosedChat function
 * @param {string} callerName
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendChatExitMsg = function (customerClosedChat, callerName) {
	try {
		if (this.chat != null && this.framework.isConnected()) {
			/** @type {string} */
			var cid = this.chat.getChatID();
			/** @type {com.inq.flash.messagingframework.Message} */
			var msg = new com.inq.flash.client.data.ChatExitMessage(cid, callerName);
			this.sendMessage(
				msg,
				function() {
					com.inq.flash.client.control.FlashPeer.fireNativeSurveyLaunchEvent();
					if (typeof customerClosedChat === "function") {
						customerClosedChat();
					}
				},
				function() {
					com.inq.flash.client.control.FlashPeer.logError("Message CHAT.EXIT was not sent: Request failed.", null, cid);
					if (typeof customerClosedChat === "function") {
						customerClosedChat();
					}
				});
				/* This results in a "chat.exit" message */
		} else {
			var messageNotSentReasons = [];

			if (this.chat === null) {
				messageNotSentReasons.push("ApplicationController.chat is null");
			}

			if (!this.framework.isConnected()) {
				messageNotSentReasons.push("ApplicationController.framework.isConnected() === false");
			}

			com.inq.flash.client.control.FlashPeer.logError("Message CHAT.EXIT was not sent: " + messageNotSentReasons.join(", "));

			if (typeof customerClosedChat === "function") {
				customerClosedChat();
			}
		}
	} catch (e) {
		var message = "Message CHAT.EXIT was not sent" + (e ? ": " + e.message : "");
		var errorObject = e || null;
		com.inq.flash.client.control.FlashPeer.logError(message, errorObject);
	}
};

/**
 * checkForChatExit
 *
 * $type TFun([],TEnum(Void,[]))
 * public function checkForChatExit():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.checkForChatExit = function() {
	if(this.waitingToExitChat) {
		this.skinControl.sendExitMsg(null, "checkForChatExit");
	}
};


/**
 * setSocketIP
 *
 * $type TFun([{ name => crAddress, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setSocketIP(crAddress:String):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  crAddress
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.setSocketIP = function(crAddress) {
	haxe.Log.trace("setSocketIP:207 crAddress=" + crAddress,{ fileName : "ApplicationController.hx", lineNumber : 838, className : "com.inq.flash.client.control.ApplicationController", methodName : "setSocketIP"});
	haxe.Log.trace("setSocketIP:213 crAddress=" + crAddress,{ fileName : "ApplicationController.hx", lineNumber : 844, className : "com.inq.flash.client.control.ApplicationController", methodName : "setSocketIP"});
	this.persistentFrameReconnect();
	haxe.Log.trace("setSocketIP:215 crAddress=" + crAddress,{ fileName : "ApplicationController.hx", lineNumber : 846, className : "com.inq.flash.client.control.ApplicationController", methodName : "setSocketIP"});
};

/**
 * setQueueMessages
 */
com.inq.flash.client.control.ApplicationController.prototype.setQueueMessages = function() {
	this.authorizedOnce = true;
	this.attemptingConnection = false;

	if (this.queueMessages) {
		this.queueMessages = false;
		this.sendQueuedMessages();
	}
};

/**
 * Sends messages from queue
 */
com.inq.flash.client.control.ApplicationController.prototype.sendQueuedMessages = function() {
	/** @type {com.inq.flash.messagingframework.Message} */
	var msg;
	for (var i = 0; i < this.messageQueue.length; i++) {
		msg = this.addTimeDeltaToMessage(this.messageQueue[i]);
		if (!this.isChatContinued() || msg.getMessageType() !== com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER) {
			this.sendMessage(msg);
		}
	}
	/* now reset the array */
	this.messageQueue.length = 0;
};


/**
 * sendFirstQueuedMessage - takes the first message from the queue and sends it out
 * This is required for service of the ChatAuthorizedMessageHandler
 * When the ChatAuthorizedMessageHandler gets the authorized event, then we must send the first queued message
 * When the ChatAcceptedMessageHandler gets the accepted event, then we must send all the other queued messages.
 *
 * If this is not done in this order, the messages are out of order on the AgentApplication screen.
 *
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * public function sendFirstQueuedMessage():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendFirstQueuedMessage = function(authTime) {
	if(!this.queueMessages || this.messageQueue.length < 1) return;/*  if we are not queueing messages, or we don't have queued messages, return*//*  if we are not queueing messages, or we don't have queued messages, return*/

	for(var i = 0; i < this.messageQueue.length; i++) {
		var message = this.messageQueue[i]["msg"];
		if(authTime && message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION) {
			message.addProperty(com.inq.flash.client.data.MessageFields.KEY_TIME_LOG, authTime);
            if (Application.application.isVirtualAgent()) {
				this.addPageDataToMessage(message);
            }
		}
	}
};


/**
 * playQueueMessages
 *
 * $type TFun([],TEnum(Void,[]))
 * public function playQueueMessages():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.playQueueMessages = function() {
	for (var i = 0; i < this.messageQueue.length; i++) {
		/** @type {com.inq.flash.messagingframework.Message} */
		var msg = this.addTimeDeltaToMessage(this.messageQueue[i]);
		this.framework.sendMessage(msg);
	}
};


/**
 * shouldBeDisconnected
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function shouldBeDisconnected():Bool
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.shouldBeDisconnected = function() {
	return this.intentionalDisconnect;
};


/**
 * shutdownQuietly
 *
 * $type TFun([],TEnum(Void,[]))
 * public function shutdownQuietly():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string} reason
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.shutdownQuietly = function(reason) {
	this.intentionalDisconnect = true;
	this.framework.disconnect(reason);
};


/**
 * shutdown
 *
 * $type TFun([],TEnum(Void,[]))
 * public function shutdown():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string} reason
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.shutdown = function(reason) {
	this.shutdownQuietly(reason);
	if(this.waitingToExitChat == true) {
		return;
	}
	this.skinControl.agentClosesChat();
};

/**
 * sendAutomatonDataMessage
 * Must be used to send Form data from ACIF.
 * Messages sent via this method are not visible in AI,
 * but present in Email transcript.
 * @param text
 */
com.inq.flash.client.control.ApplicationController.prototype.sendAutomatonDataMessage = function(text) {

	/** @type {Date} */
	var messageTimestamp = new Date();
	/** @type {number} */
	var loc = com.inq.flash.client.chatskins.SkinControl.addAutomatonDataToChatWindow(text, -1, null, "", messageTimestamp);
	/** @type {com.inq.flash.client.data.ChatAutomatonDataMessage} */
	var message = new com.inq.flash.client.data.ChatAutomatonDataMessage(this.chat, text);

	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"" + loc);
	/** @type {number} */
	var msgTimestamp = Date.now();
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP, msgTimestamp);

	this.sendMessageOrQueue(message);
};



/**
 * sendChatCommunicationMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.client.data.ChatCommunicationMessage,[]), opt => false },{ name => loc, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function sendChatCommunicationMessage(message:ChatCommunicationMessage, loc:Int):Void
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.client.data.ChatCommunicationMessage}  message
 * @param {number}  loc
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendChatCommunicationMessage = function(message, loc) {
	//AI/CR uses Customer Name from 'chat.request' message, so "client.name" here will be ignored
	//message.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME,com.inq.flash.client.control.FlashVars.getFlashVars().userName);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"" + loc);
	var messageTimestamp = Date.now();
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP, messageTimestamp);

	if(!this.attemptingConnection && !this.intentionalDisconnect && !this.framework.isConnected() && !this.wasConnected) {
		this.sendButtonClickedTime = Math.round(new Date().getTime());

		try {
			haxe.Log.trace("attemptingConnection",{ fileName : "ApplicationController.hx", lineNumber : 734, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatCommunicationMessage"});
			this.attemptingConnection = true;
			haxe.Log.trace("queueMessages",{ fileName : "ApplicationController.hx", lineNumber : 736, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatCommunicationMessage"});
			this.queueMessages = true;
			haxe.Log.trace("do a send text",{ fileName : "ApplicationController.hx", lineNumber : 738, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatCommunicationMessage"});
			this.sendText(message);
			haxe.Log.trace("framework.connect()",{ fileName : "ApplicationController.hx", lineNumber : 740, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatCommunicationMessage"});
			this.framework.connect();
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "ApplicationController.hx", lineNumber : 743, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatCommunicationMessage"});
			} else throw(e);
		}
	} else
	this.sendText(message);
};

/**
 * Is used to setup engage parameters from Automaton through XFrameWorker that will used to engage chat at first message from customer.
 * @see com.inq.flash.client.control.XFrameWorker.setEngageParameters

 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {Object} chatParams - parameters to engage the chat, such as:
 *     agentOutcome {string}
 *     clientOutcome {string}
 *     agentAttrs {string}
 *     businessUnitID {string}
 *     phone {string}
 *     agentGroupId {string}
 *     scriptTreeId {string}
 *     circularTabbing {boolean}
 *     publicUserId {string}
 *     automatonId {string}
 *     automatonFields {string}
 *     overrideAgentAlias {boolean}
 *     agentName {string}
 *
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.prepareEngageChat = function (chatParams) {
	if (!this.attemptingConnection && !this.intentionalDisconnect && (this.chatRouterListen || !this.framework.isConnected() && !this.wasConnected)) {
		this.setEngageParameters(chatParams);

		/** @type {com.inq.flash.client.data.ChatEngageMessage} */
		var message = new com.inq.flash.client.data.ChatEngageMessage(this.chat, chatParams["agentOutcome"], chatParams["clientOutcome"], this.getAgentAlias());

		if (chatParams["phone"]) {
			this.addInitialData(message, "CallerPhone", chatParams["phone"], "CallerPhone");
		}

		var loc = -1;
		if (chatParams["clientOutcome"]) {
			loc = this.addClientOutcomeToChatWindow(chatParams["clientOutcome"]);
		}
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, loc);

		this.queueMessages = true;
		this.sendText(message);
		return true;
	}
	return false;
};

/**
 * Is used to engage the chat from Automaton through XFrameWorker
 * @see com.inq.flash.client.control.XFrameWorker.engageChat
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {Object} chatParams - parameters to engage the chat, such as:
 *     agentOutcome {string}
 *     clientOutcome {string}
 *     agentAttrs {string}
 *     businessUnitID {string}
 *     phone {string}
 *     agentGroupId {string}
 *     scriptTreeId {string}
 *     circularTabbing {boolean}
 *     publicUserId {string}
 *     automatonId {string}
 *     automatonFields {string}
 *     overrideAgentAlias {boolean}
 *     agentName {string}
 *
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.engageChat = function (chatParams) {
	if(!this.attemptingConnection && !this.intentionalDisconnect && (this.chatRouterListen || !this.framework.isConnected() && !this.wasConnected)) {
		this.sendButtonClickedTime = Math.round(new Date().getTime());
		this.setEngageParameters(chatParams);

		/** @type {com.inq.flash.client.data.ChatEngageMessage} */
		var message = new com.inq.flash.client.data.ChatEngageMessage(this.chat, chatParams["agentOutcome"], chatParams["clientOutcome"], this.getAgentAlias());

		if (chatParams["phone"]) {
			this.addInitialData(message, "CallerPhone", chatParams["phone"], "CallerPhone");
		}

		/**
		 * @see RTDEV-10287
		 * @description: cientOutcome is added to the chat window . Because of this there is no need to wait for the data pass through response
		 * @type {number}
		 */

		var loc = -1;
		/**
		 * moving it to autoOpener as opener script is being read after a delay
		 */
		if(chatParams["clientOutcome"]) {
			loc = this.addClientOutcomeToChatWindow(chatParams["clientOutcome"]);
		}

		this.sendChatCommunicationMessage(message,loc);
		return true;
	}
	return false;
};

/**
 * Apply engage parameters to chat.
 * This parameters will used to engage chat to agent.
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param chatParams
 */
com.inq.flash.client.control.ApplicationController.prototype.setEngageParameters = function (chatParams) {
	if (chatParams["agentAttrs"]) {
		this.chat.setAgentAttributes(chatParams["agentAttrs"]);
	}
	if (chatParams["businessUnitID"]) {
		this.chat.setBusinessUnitID(chatParams["businessUnitID"]);
	}
	if (chatParams["agentGroupId"]) {
		this.chat.setAgentGroupID(chatParams["agentGroupId"]);
	}
	if (chatParams["publicUserId"]) {
		this.chat.setPublicUserId(chatParams["publicUserId"]);
	}
	if (chatParams["scriptTreeId"]) {
		this.chat.setScriptID(chatParams["scriptTreeId"]);
	}
	if (chatParams["automatonId"]) {
		this.chat.setAutomatonId(chatParams["automatonId"]);
		if (chatParams["automatonFields"]) {
			this.chat.setAutomatonFields(chatParams["automatonFields"]);
		}
	}
    if (!chatParams["agentName"] && chatParams["overrideAgentAlias"] === true) {
        haxe.Log.trace("ERROR: setEngageParameters: agentName is empty. Cannot override agent alias");
    } else if (typeof chatParams["overrideAgentAlias"] === "boolean") {
        com.inq.flash.client.control.FlashVars.setValue("overrideAgentAlias", "" + chatParams["overrideAgentAlias"]);
    }
    if (chatParams["agentName"]) {
        com.inq.flash.client.control.FlashVars.setAgentName(chatParams["agentName"]);
        this.chat.setAgentName(chatParams["agentName"]);
    }

	if (chatParams["queueThreshold"]) {
		this.chat.setQueueThreshold(chatParams["queueThreshold"]);
	}


	this.chat.setRoutingAllocSpecs(chatParams.routingAllocSpecs);

	// Save target parameters to session cookie (in case of page reloads)
	this.persistEngageChatParameters(chatParams, ["businessUnitID", "agentGroupId"]);
};

/**
 * Persist target chatParameter by name and only saves 
 * if the parameter is present.
 * 
 * @param {Object} chatParams - Chat paramerter object
 * @param {Array} parameterNamesToSave - Array of target parameters to save
 */
com.inq.flash.client.control.ApplicationController.prototype.persistEngageChatParameters = function (chatParams, parameterNamesToSave) {
	var paramsToSave = {};
	var SHORT_NAME_MAP = {
		"businessUnitID": BUSINESS_UNIT_ID,
		"agentGroupId": AGENT_GROUP_ID
	};
	var save = false;
	parameterNamesToSave.forEach(function (parameterName) {
		if (chatParams[parameterName]) {
			var saveToName = SHORT_NAME_MAP[parameterName] || parameterName;
			paramsToSave[saveToName] = chatParams[parameterName];
			save = true;
		}
	});

	if (save) {
		com.inq.flash.client.control.PersistenceManager.SetValue(
			ENGAGE_CHAT_PARAMS,
			paramsToSave
		);
	}
};

/**
 * Display client outcome as opener
 * @param {string} clientOutcome
 * @returns {number} location in transcript
 */
com.inq.flash.client.control.ApplicationController.prototype.addClientOutcomeToChatWindow = function (clientOutcome) {
	/** @type {Object} */
	var expressionObject = this.skinControl.checkForSpecialExpression(clientOutcome);
	return this.skinControl.AddOpenerToChatWindow(
		StringTools.htmlUnescape(this.getAgentAlias()),
		expressionObject.text,
		com.inq.flash.client.chatskins.ChatTextArea.AGENT,
		-1,
		expressionObject.expressionList
	);
};

/**
 * getAgentAlias
 *
 * $type TFun([],TInst(String,[]))
 * public function getAgentAlias():String
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {string}
 */
com.inq.flash.client.control.ApplicationController.prototype.getAgentAlias = function() {
	/** @type {string} */
	var agentName = com.inq.flash.client.control.FlashVars.getFlashVars()["agentName"];
    if (com.inq.utils.Util.isDefaultAgentAlias()) {
        agentName = com.inq.utils.Util.getConfig("defaultAgentAlias", "&nbsp;");
    }
	return agentName;
};


/**
 * sendButtonClicked
 *
 * $type TFun([],TEnum(Void,[]))
 * public function sendButtonClicked():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {String} text Message text
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendButtonClicked = function (text) {
	if (com.inq.utils.StringUtil.isEmptyString(text)) {
		haxe.Log.trace(
			"sendButtonClicked: no text",
			{
				fileName : "ApplicationController.js",
				className : "com.inq.flash.client.control.ApplicationController",
				methodName : "sendButtonClicked"
			}
		);
		return;
	}

	haxe.Log.trace(
		"sendButtonClicked enter"
			+ "\nCheck connections: "
			+ "\n\tattemptingConnection=" + Std.string(this.attemptingConnection)
			+ "\n\tintentionalDisconnect=" + Std.string(this.intentionalDisconnect) + "\n",
		{
			fileName : "ApplicationController.js",
			className : "com.inq.flash.client.control.ApplicationController",
			methodName : "sendButtonClicked"
		}
	);

	com.inq.flash.client.chatskins.SkinControl.customerTypedText = "";
	var messageTimestamp = new Date();
	/** @type {number} */
	var loc = this.appendSentText(text, -1, messageTimestamp);
	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat, text, this.isUpdateUsername());
	/** @type {string} */
	var displayText = "";

	if (text.toLowerCase() === com.inq.flash.client.data.MessageFields.KEY_CHAT_INFO) {
		displayText = "Customer requested Chat Info";
	} else if (text.toLowerCase().startsWith(com.inq.flash.client.data.MessageFields.KEY_SWITCH_DEBUG)) {
		displayText = "Customer enabled debug mode";
	}

	if (displayText) {
		message.addProperty(
			com.inq.flash.client.data.MessageFields.KEY_DISPLAY_TEXT,
			displayText
		);
	}

    if (Application.application.isVirtualAgent()) {
		this.addPageDataToMessage(message);
    }
	this.sendChatCommunicationMessage(message,loc);

	// after sending of message we should cancel the flag of updating
	if (this.isUpdateUsername()) {
		this.cancelUpdateUsername();
	}
};

/**
 * sendVALinkClicked
 * Processing clicks on virtual agent dialog links
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendVALinkClicked = function(event) {
	var eventTarget = event.target || event.srcElement;
	var el;

	//if any element (i.e. "IMG") is wrapped in "A", it should be handled in the same way.
	//thus we are looking for the nearest "A" and working with its data-attributes.
	if (eventTarget.tagName == "A") {
		el = eventTarget;
	} else {
		el = findEl(eventTarget, event.currentTarget);
	}

	function findEl(el, currTarget) {
		while (el.parentNode && el != currTarget) {
			el = el.parentNode;
			if (el.tagName === "A") {
				return el;
			}
		}
		return null;
	}

	if (!el) {
		return;
	}

	// according to Nuance's VA service specification 'data-vtz-jump' attr exists only at dialog links,
	// so we can determine these links by checking this attribute
	/** @type {string} */
	var vtzJump = el.getAttribute("data-vtz-jump");

	// according to Nuance's VA service specification external web links contains
	// "data-vtz-link-type" attribute equal to “Web”,
	// and "data-vtz-browse" attr with URL inside.
	/** @type {string} */
	var linkType = el.getAttribute("data-vtz-link-type");
	/** @type {string} */
	var vtzBrowse = el.getAttribute("data-vtz-browse");
	/** @type {string} */
	var text;
	/** @type {boolean} */
	var hiddenMessage = false;
	/** @type {boolean} */
	var setTiFocus = true;
	/** @type {string} */
    var targetHref = event.target.href;

	if (linkType == "Web" && vtzBrowse) {
        /*
         * If it's an external web link in opener, wait for chat to be assigned
         * before redirecting (handled in StateChangeMessageHandler).
         */
		if (targetHref.indexOf("http") === 0) {
			if (this.openerMessageQueue.length > 0) {
				event.preventDefault();
				this.webOpenerLinkHref = targetHref;
			/*
			 * isWebExternalVALink is utilised in URLLoader to make a sync XHR
	 		 * post request before redirecting user to a different page.
			 */
			} else {
				com.inq.flash.client.control.ApplicationController.isWebExternalVALink = true;
			}
		}

		// according to Nuance's VA service specification for links with 'data-vtz-browse' attr,
		// in addition to this navigation, the caller should call the web service sending “##Url#url value” as the UserText
		text = "##Url#" + vtzBrowse;
		hiddenMessage = true;
		// per RTDEV-21637, TalkAgentRequest.UserText should be limited to 100 chars.
        text = text.substring(0, 100);
	} else if (linkType == "Dialog") {
		text = el.text;
		/** @type {number} */
		var loc = this.appendSentText(text, -1);
		event.preventDefault ? event.preventDefault() : (event.returnValue = false);
	} else if (event.type == "touchend" && targetHref) {
		event.preventDefault();
		/* A timeout is necessary here, because a simultaneous call to VA and url change is resulting in a network error when
		communicating with VA and does a retry which sometimes is resulting in  duplicate requests. Note this is observed only iphones */
		window.setTimeout(function () {
			window.parent.location.href = targetHref;
		}, 1000);
		setTiFocus = false;
	}
	else {
		return;
	}

	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var  message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat,text);

    var elAttributes = el.attributes;
    for (var i = 0; i < elAttributes.length; i++) {
    	var name = elAttributes[i].name;
        if (name.startsWith("data-vtz")) {
            message.addPropertyIfNotNull(name.replace("data-", ''), elAttributes[i].value);
        }
	}

	if (hiddenMessage) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT, "0");
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA_HIDDEN_FOR_CUSTOMER, "true");
	}
	this.addPageDataToMessage(message);

	this.sendChatCommunicationMessage(message, loc);

	if (!com.inq.flash.client.chatskins.SkinControl.isTxtInputAutofocusBlocked() && setTiFocus) {
		Application.application.setTextFieldfocus();
	}
};

/**
 * Sets survey config and fires event to load native post chat survey
 *
 * @param {MouseEvent|TouchEvent} event
 */
com.inq.flash.client.control.ApplicationController.prototype.launchPostChatSurvey = function (event) {
	var eventTarget = event.target;

	if (eventTarget) {
		com.inq.flash.client.control.FlashPeer.launchNativePostChatSurvey(
			eventTarget.getAttribute(com.inq.flash.client.chatskins.SkinControl.DATA_SURVEY_URL)
		);
	}

	event.preventDefault();
};

/**
 * addPageDataToMessage
 * Adds the URL and pagemarker of the current page to message
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.addPageDataToMessage = function (message) {
	message.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CLIENT_PAGE_LOCATION, com.inq.utils.Util.getTopWindowURL());
	message.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_PAGE_MARKER_ID, com.inq.flash.client.control.FlashPeer.getPageMarker());
};

/**
 * agentQuickResponse
 * sends chosen option as a message
 * if link - sends as message and navigate
 * @this com.inq.flash.client.control.ApplicationController
 * @param {Event}  event - click event on link
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.agentQuickResponse = function (event) {

	var eventTarget = event.target;
	var responseText = eventTarget.getAttribute("data-nuance-quick-answer");
	var targetBlank = (eventTarget.getAttribute("target") == "_blank");
	var clickedLink = eventTarget.href;

	//protection against incorrect configuration
	if (!targetBlank) {
		event.preventDefault();
	}

	if (!responseText) {
		if (clickedLink && clickedLink.length) {
			responseText = '##URL#' + clickedLink;
		}
	}
	var loc = this.appendSentText(responseText, -1);
	var message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat, responseText);
	this.sendChatCommunicationMessage(message, loc);
};


/**
 * callButtonClicked
 *
 * $type TFun([],TEnum(Void,[]))
 * public function callButtonClicked():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.callButtonClicked = function(text, callStreamData, callerNameString) {

	this.callStreamData = callStreamData;
	/** @type {com.inq.flash.client.data.CallCommunicationMessage} */
	var message = new com.inq.flash.client.data.CallCommunicationMessage(this.chat, text);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME,callerNameString);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"-1");
	message.addProperty("fromV3",callerNameString);
	com.inq.flash.client.control.PersistenceManager.SetValue(CLIENT_NAME_PERSIST,callerNameString);
	this.queueMessages = true;
	this.sendMessageOrQueue(message);
	this.chatRouterListen = false;
};


/**
 * Returns the boolean flag meaning that chat application can communicate with the chat router.
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isConnected = function() {
	if(this.framework == null) return false;
	return this.framework.isConnected();
};

/**
 * Returns true if last message returned fail status to mark that there is no network connection
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isSendMessageFail = function() {
	if (this.framework) {
		return this.framework.isSendMessageFail();
	} else {
		return false;
	}
};

/**
 * Response timestamp is used for detection the last successful response from the server
 * to monitor the time of the connection issue.
 * If returns 0 that means the response had not received even once.
 * @returns {number}
 */
com.inq.flash.client.control.ApplicationController.prototype.getResponseTimestamp = function() {
	if (this.framework) {
		return this.framework._getResponseTimestamp();
	} else {
		return 0;
	}
};

/**
 * localChatRouterListen - listen for messages from the chat router that are "local"
 * meaning that they come from another browser on the same machine
 * This is used to see if there is an existing chat or persistent chat active
 *
 * $type TFun([],TEnum(Void,[]))
 * public function localChatRouterListen():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.localChatRouterListen = function() {
	try {
		if(this.framework.isConnected()) return;
		this.attemptingConnection = true;
		this.queueMessages = true;
		/** @type {number} */
		var count = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0);
		this.framework.setParam("count",count);
		this.framework.connect();
		this.chatRouterListen = true;
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {

			haxe.Log.trace("Error: " + Std.string(e),{ fileName : "ApplicationController.hx", lineNumber : 635, className : "com.inq.flash.client.control.ApplicationController", methodName : "localChatRouterListen", customParams : ["error"]});
		} else throw(e);
	}
};


/**
 * persistentFrameReconnect
 *
 * $type TFun([],TEnum(Void,[]))
 * public function persistentFrameReconnect():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.persistentFrameReconnect = function() {
	try {
		if(!this.attemptingConnection) {
			this.attemptingConnection = true;
			this.queueMessages = true;
			/** @type {number} */
			var count = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0);
			this.framework.setParam("count",count);

			/*
			 * chatserver will be kicked by "getMessages" which will be send inside connect() below
			 * kicking = "connection.setLastAccessedTime(System.currentTimeMillis())"
			 *
			 */
			this.persistentReconnect = true;
			this.chatRouterListen = false;
			this.framework.connect();
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("Error: " + Std.string(e),{ fileName : "ApplicationController.hx", lineNumber : 614, className : "com.inq.flash.client.control.ApplicationController", methodName : "persistentFrameReconnect"});
		} else throw(e);
	}
};


/**
 * connectionLost
 *
 * $type TFun([],TEnum(Void,[]))
 * public function connectionLost():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.connectionLost = function() {
	haxe.Log.trace("connectionLost();",{ fileName : "ApplicationController.hx", lineNumber : 591, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionLost"});
	this.queueMessages = true;
};


/**
 * setAgentConfig
 *
 * $type TFun([{ name => agentID, t => TInst(String,[]), opt => false },{ name => eventData, t => TInst(com.inq.utils.Dictionary,[]), opt => false },{ name => coBrowseEnabled, t => TEnum(Bool,[]), opt => true },{ name => buID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  agentID string representation of agent ID
 * @param {com.inq.utils.Dictionary}  eventData includes agent last name, first name and agent attributes
 * @param {boolean}  coBrowseEnabled  flag shows is CoBrowse is enabled
 * @param {string}  buID chat business unit ID
 * @param {string}  agentGroupID chat owner's agent group ID
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.setAgentConfig = function(agentID,eventData,coBrowseEnabled,buID,agentGroupID) {
	if(coBrowseEnabled == null) coBrowseEnabled = false;
	haxe.Log.trace("ApplicationController.setAgentConfig('" + agentID + "')",{ fileName : "ApplicationController.hx", lineNumber : 585, className : "com.inq.flash.client.control.ApplicationController", methodName : "setAgentConfig"});
	this.agentID = agentID;
	this.setFlagChatInQueue(false);
	this.skinControl.setTypingActivity(false);
	this.skinControl.setAgentConfig(agentID, eventData, coBrowseEnabled, buID, agentGroupID);
};


/**
 * urlStringToObject
 *
 * $type TFun([{ name => urlStr, t => TInst(String,[]), opt => false }],TInst(com.inq.utils.Dictionary,[]))
 * private function urlStringToObject(urlStr:String):Dictionary
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  urlStr
 * @return {com.inq.utils.Dictionary}
 */
com.inq.flash.client.control.ApplicationController.prototype.urlStringToObject = function(urlStr) {
	/** @type {com.inq.utils.Dictionary} */
	var retObj = new com.inq.utils.Dictionary();
	/** @type {Array} */
	var strArr = StringTools.urlDecode(urlStr).split("&");
	for (var i = 0; i < strArr.length; i++) {
		/** @type {string} */
		var item = strArr[i];
		/** @type {Array} */
		var nvPair = item.split("=");
		if(nvPair.length == 2) {
			/** @type {string} */
			var name = nvPair[0];
			/** @type {string} */
			var val = nvPair[1];
			retObj[name] = val;
		}
	}
	return retObj;
};

/**
 * sendMessage
 *
 * $type TFun([{ name => msg, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * private function sendMessage(msg:Message):Void
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.messagingframework.Message} msg
 * @param {function=} successListener - callback function on success message delivery.
 * @param {function=} errorListener - callback function on error message delivery.
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendMessage = function(msg, successListener, errorListener) {
	this.addClickStreamData(msg);
	this.framework.sendMessage(msg, successListener, errorListener);
	if (com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION == msg.getMessageType() && Application.application.notificationController) {
		Application.application.notificationController.hideNotification();
	}
};

/**
 * initializeAutomatonMode
 * if chat starts in  automaton mode, send CHAT_REQUEST msg (AUTOMATION-1)
 *
 * $type TFun([],TEnum(Void,[]))
 * public function initializeAutomatonMode():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean} true if connection was established
 */
com.inq.flash.client.control.ApplicationController.prototype.initializeAutomatonMode = function() {
	if (this.isAutomatonMode() && !this.framework.isConnected() && !this.skinControl.isContinued()) {
		haxe.Log.trace("initializing Inline DT automaton",{ fileName : "ApplicationController.hx", lineNumber : 553, className : "com.inq.flash.client.control.ApplicationController", methodName : "initializeAutomatonMode"});
		this.sendButtonClickedTime = Math.round(new Date().getTime());
		this.queueMessages = true;
		this.framework.connect();
		this.skinControl.StopTimer();
		return true;
	}
	return false;
};


/**
 * return true if chat starts in automaton mode
 *
 * For Virtual agent chat request should be sends after customer sends first message
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isAutomatonMode = function() {
	return this.chat.getAutomatonId() > 0 && !this.chat.isSendChatRequestOnDemand()
		&& !com.inq.flash.client.control.FlashPeer.getVAList().includes(this.chat.getAutomatonId());
};


/**
 * addInitialData
 *
 * $type TFun([{ name => msg, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false },{ name => name, t => TInst(String,[]), opt => false },{ name => data, t => TInst(String,[]), opt => false },{ name => label, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function addInitialData(msg:Message, name:String, data:String, label:String)
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.messagingframework.Message}  msg
 * @param {string}  name
 * @param {string}  data
 * @param {string}  label
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.addInitialData = function(msg,name,data,label) {
	/** @type {string} */
	var prefix = com.inq.flash.client.data.MessageFields.KEY_INITIAL_CLICKSTREAM_PREFIX + msg.nextInitialDataIndex();
	msg.addProperty(prefix + ".id",name);
	msg.addProperty(prefix + ".data", data);

	if(label != null && label != "" && label != "undefined") msg.addProperty(prefix + ".label",label);
};

/**
 * add clickstream data to first CHAT_COMMUNICATION message
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.messagingframework.Message} msg
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.addClickStreamData = function(msg) {
	if(com.inq.flash.client.control.PersistenceManager.GetValue(CLICK_STREAM_DATA_SENT_KEY,0) == 0) this.bSendClickStreamData = true;
	if(!this.bSendClickStreamData) return;
	/*  add Clickstream data only for CHAT_COMMUNICATION* messages */
	/*  In case of pre-chat survey the TYPE_CHAT_COMMUNICATION_OUTCOME is the first message to the agent */
	/*  which carries customer filled pre-chat survey information to the agent. */
	/*  I am not returning when the message type is TYPE_CHAT_COMMUNICATION_OUTCOME, */
	/*  so that Clickstream data is sent to the agent when first time the chat is routed to the agent. */
	if (
		com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION != msg.getMessageType()
		&& com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER != msg.getMessageType()
		&& com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE != msg.getMessageType()
		&& com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_RESPONSE != msg.getMessageType()
		&& com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME != msg.getMessageType()
	) {
		return;
	}
	/** @type {boolean} */
	var isPersistent = com.inq.flash.client.control.FlashPeer.isPersistentWindow();
	/** @type {string} */
	var initialClickstreamData = this.skinControl.getInitialClickstreamData();
	if (isPersistent || this.skinControl.isClick2WebCall() || com.inq.flash.client.control.WebRTCMgr.isEngaged) {
		try {
			initialClickstreamData += this.skinControl.getOpener().Application.application.applicationController.callStreamData;
		} catch (err) {
			haxe.Log.trace(
				"ApplicationController.addClickstreamData Error" + Std.string(err),
				{
					fileName: "ApplicationController.js",
					className: "com.inq.flash.client.control.ApplicationController",
					methodName: "addClickStreamData"
				}
			);
		}
	}
	haxe.Log.trace(
		"ApplicationController.addClickstreamData: clickStreamData = " + initialClickstreamData,
		{
			fileName: "ApplicationController.js",
			className: "com.inq.flash.client.control.ApplicationController",
			methodName: "addClickStreamData"
		}
	);
	this.bSendClickStreamData = false;

	/** @type {com.inq.utils.Dictionary} */
	var fieldDictionary = new com.inq.utils.Dictionary();
	if(initialClickstreamData == null) return;
	/*  chat was reloaded */
	/** @type {Array} */
	var csFields = initialClickstreamData.split("^^");

	// first populate the dictionary
	for (var i = 0; i < csFields.length; i++) {
		/** @type {string} */
		var fieldItem = csFields[i];
		if (fieldItem !== "") {
			/** @type {Array} */
			var field = fieldItem.split("=");

			/*
			 * we want the first item in the array as the field name
			 * if we shift it off the top (same as a pop, but from the other end)
			 * we then get an array of all values separated by the equal signs
			 * the first parameter is no longer there.
			 * when we re-join them together with the equal sign, then
			 * we have the resultant data with any embedded equal signs
			 */
			/** @type {string} */
			var fieldname = field.shift(); // was String(field[0]);
			/** @type {string} */
			var value = field.join("="); // was String(field[1]);
			fieldDictionary[fieldname] = value;
		}
	}

	/* now populate the message */
	/** @type {number} */
	var fieldID = 0;
	for (var j = 0; j < csFields.length; j++) {
		/** @type {string} */
		var csField = csFields[j];
		if("" == csField) continue;
		haxe.Log.trace("field is " + csField,{ fileName : "ApplicationController.hx", lineNumber : 511, className : "com.inq.flash.client.control.ApplicationController", methodName : "addClickStreamData"});
		/** @type {string} */
		var name = csField.split("=").shift();
		if(name == null) continue;
		if(name.charAt(0) != "_") {
			/** @type {string} */
			var data = fieldDictionary[name];
			/** @type {string} */
			var label = fieldDictionary["_" + name];
			this.addInitialData(msg,name,data,label);
			fieldID++;
		}
	}

	/*  Now that we sent, set the flag */
	com.inq.flash.client.control.PersistenceManager.SetValue(CLICK_STREAM_DATA_SENT_KEY,1);
};

/**
 * connectionEstablished
 *
 * $type TFun([],TEnum(Void,[]))
 * public function connectionEstablished():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.connectionEstablished = function() {
	try {
		com.inq.flash.client.control.FlashPeer.setCABeacon(this.chat.BEACON_ACTIVATE);
		/** @type {string} */
		var connectionType = this.framework.getConnectionType();
		com.inq.flash.client.chatskins.SkinControl.connectionType = connectionType;
		/** @type {com.inq.ui.TextInput} */
		var ti = Application.application.getTextInput("txtInput").setEnabled(true);
		this.wasConnected = true;

		if (!com.inq.flash.client.chatskins.SkinControl.isContinued()
			|| com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) == 0) {

			haxe.Log.trace("ApplicationController.connectionEstablished, sending a chat request message",{ fileName : "ApplicationController.hx", lineNumber : 407, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionEstablished"});

			this.sendChatRequestMessage(this.chat.isAsyncReconnect());
		} else if (this.isAgentAssigned()) {
			this.setConnectionAccepted(true);
		}
		Application.application.setActiveWindowId();
		haxe.Log.trace("framework.sendMessage(chat.request) sent",{ fileName : "ApplicationController.hx", lineNumber : 432, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionEstablished"});
		if(this.persistentReconnect) {
			this.playQueueMessages();
			this.queueMessages = false;
		}
	} catch( e ) {
		haxe.Log.trace("Exception: " + Std.string(e),{ fileName : "ApplicationController.hx", lineNumber : 438, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionEstablished"});
	}
	haxe.Log.trace("exit connectionEstablished",{ fileName : "ApplicationController.hx", lineNumber : 440, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionEstablished"});
};

com.inq.flash.client.control.ApplicationController.prototype.sendChatRequestMessage = function(reconnect) {
    /** @type {boolean} */
	var isPersistent = com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat();

    if (isPersistent) {
        if (this.notifiedAsPersistent)
            isPersistent = false;
        else
            this.notifiedAsPersistent = true;
    }

    /** @type {com.inq.flash.client.data.ChatRequestMessage} */
    var message = null;
    try {
        haxe.Log.trace("ApplicationController: creating msg. chat=" + this.chat.toString(),{ fileName : "ApplicationController.hx", lineNumber : 410, className : "com.inq.flash.client.control.ApplicationController", methodName : "connectionEstablished"});
		haxe.Log.trace(
			"ApplicationController: creating msg. isPersistent=" + Std.string(isPersistent)
			+ ", agentID=" + this.agentID,
			{
				fileName: "ApplicationController.hx",
				className: "com.inq.flash.client.control.ApplicationController",
				methodName: "connectionEstablished"
			}
		);
        /** @type {number} */
        var deltaTime = this.sendButtonClickedTime != null ? Math.round(new Date().getTime()) - this.sendButtonClickedTime : 0;
        message = new com.inq.flash.client.data.ChatRequestMessage(this.chat, isPersistent, this.agentID, deltaTime, this, reconnect);
        // set flag that the chat is engaged
        com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_ENGAGED, true, false, true);
        if (com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
            message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CALL_ENABLED, "true");
            message.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME, com.inq.flash.client.control.PersistenceManager.GetValue(CLIENT_NAME_PERSIST, com.inq.flash.client.chatskins.SkinControl.getCallerNameString()));
        }
        haxe.Log.trace("ApplicationController: msg sent. msg=" + message.toString(),{ fileName : "ApplicationController.hx", lineNumber : 1337, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatRequestMessage"});
	} catch (err) {
        haxe.Log.trace("Exception: " + Std.string(err),{ fileName : "ApplicationController.hx", lineNumber : 1339, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatRequestMessage", customParams : ["error"]});
    }

    haxe.Log.trace("framework.sendMessage(message):" + message.toString(),{ fileName : "ApplicationController.hx", lineNumber : 1342, className : "com.inq.flash.client.control.ApplicationController", methodName : "sendChatRequestMessage"});

	if (reconnect && !this.getChat().isAsyncReconnect()) {
		this.queueMessages = true;
		this.sendMessage(
			message,
			this.framework.sendReconnectGetMessage.bind(this.framework)
		);
	} else {
		this.sendMessage(message, this.restoreTranscript.bind(this));
	}

	if (!reconnect) {
		this.updateDataInStorage();
	}
};

/**
 * Updates MESSAGE_COUNT and LAST_TOUCHED_TIME values in storage
 *
 * @param {number=} msgCount - message count
 */
com.inq.flash.client.control.ApplicationController.prototype.updateDataInStorage = function (msgCount) {
	var map = {};
	var messageCount;
	if (typeof msgCount === "number") {
		messageCount = msgCount;
	} else {
		messageCount = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	}
	map[MESSAGE_COUNT] = messageCount;
	map[LAST_TOUCHED_TIME] = Date.now();
	com.inq.flash.client.control.PersistenceManager.SetValues(map);
};

/**
 * Sends request to get transcript from chatrouter and clears current transcript array
 */
com.inq.flash.client.control.ApplicationController.prototype.restoreTranscript = function () {
	this.framework.getMessages();
	this.skinControl.clearOpenersArray();
	this.skinControl.clearTranscriptArray();
};

/**
 * Sends communication message from queue in connection handler.
 */
com.inq.flash.client.control.ApplicationController.prototype.sendCommunicationMessagesFromQueue = function () {
	this.framework.sendCommunicationMessagesFromQueue();
};

/**
 * isConnectionAccepted
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function isConnectionAccepted():Bool
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isConnectionAccepted = function() {
	return this.chatAccepted;
};


/**
 * setConnectionAccepted
 *
 * $type TFun([{ name => b, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public function setConnectionAccepted(b:Bool):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {boolean}  b
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.setConnectionAccepted = function(b) {
	this.chatAccepted = b;
};


/**
 * acknowledgeChatPersistent
 * The chat-router asks whether-or-not the persistent chat is active.
 * If it is we end up here.
 * We then check to see if the persistent window can talk to it's opener via "FlashPeer.registerPersistentWindow()"
 * If it can it returns true, if it cannot, it returns false.
 * If it is false, then we know that the client will reestablish this persistent chat's opener by reopening it.
 * For this reason we need to turn off the unload processing so that we do not fire persistent chat close.
 *
 * $type TFun([{ name => clientProtoDomain, t => TInst(String,[]), opt => false },{ name => messageCnt, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgeChatPersistent(clientProtoDomain:String, messageCnt:String)
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  clientProtoDomain - protocol/domain of the client page
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.acknowledgeChatPersistent = function(clientProtoDomain) {
	/** @type {boolean} */
	var b = com.inq.flash.client.control.FlashPeer.registerPersistentWindow();
	if(!b) com.inq.flash.client.chatskins.SkinControl.noUnload();
	/** @type {string} */
	var protoDomain = window.location.protocol + "//" + window.location.hostname;
	this.framework.acknowledgePersistentActive(this.chat.getChatID(),protoDomain,clientProtoDomain,!b);
};


/**
 * acknowledgeChatActive
 *
 * $type TFun([],TEnum(Void,[]))
 * public function acknowledgeChatActive()
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.acknowledgeChatActive = function() {
	this.framework.acknowledgeChatActive(this.chat.getChatID());
};

/**
 * Try to restore chat on server.
 */
com.inq.flash.client.control.ApplicationController.prototype.handleChatLost = function () {
	this.framework.handleChatLost();
};

/**
 * enable
 * Enable receiving message from agent.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * public function enable()
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.enable = function() {
    this.framework.enable();
};

/**
 * disable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function disable()
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.disable = function() {
	this.framework.disable();
	var ieVersion = com.inq.flash.client.control.FlashPeer.getBrowserMajorVer(true);
	// RTDEV-10654 causes Operation Aborted error in IE with Compatibility mode, need to skip when called from persistent window
	if(!com.inq.flash.client.control.FlashPeer.isPersistentChat() || com.inq.flash.client.control.FlashPeer.isPersistentWindow() || !com.inq.utils.Util.isIE || ieVersion > 7) {
		com.inq.flash.client.control.FlashPeer.setCABeacon(this.chat.BEACON_DEACTIVATE);
	}
};

/**
 * sendMessageOrQueue
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false },{ name => clientTime, t => TInst(Float,[]), opt => true }],TEnum(Void,[]))
 * private function sendMessageOrQueue(message:Message,?clientTime):Void
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.messagingframework.Message}  message
 * @param {number}  clientTime
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendMessageOrQueue = function(message, clientTime) {
	if(!this.queueMessages) {
		this.sendMessage(message);
	} else {
		/** @type {number} */
		var now = clientTime == null ? new Date().getTime():clientTime;
        this.messageQueue.push({"clientTime": now, "msg": message});
	}
};

/**
 * processClickToCallQueueMessages
 *
 * $type TFun([],TEnum(Void,[]))
 * public function processClickToCallQueueMessages():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.processClickToCallQueueMessages = function() {
	/** @type {Window} */
	var opener = com.inq.flash.client.chatskins.SkinControl.getOpener();

	/* I know the following code is ugly
	 * It is necessary because of obfuscation
	 * This routine calls out to another window and expects to get two getters
	 * The getters are published in the constructer above but we need to use quoted
	 * strings to avoid obfuscation
	 */
	this.openerMessageQueue = opener["com"]["inq"]["getOpenerMessageQueue"]();
	/** @type {Array} */
	var messageQueue = opener["com"]["inq"]["getMessageQueue"]();

	if(messageQueue.length > 0) {
        /** @type {com.inq.flash.client.data.CallCommunicationMessage} */
		var message = messageQueue.shift()["msg"];
        /** @type {string} */
        var clientName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME);
        com.inq.flash.client.control.FlashVars.setCustomerName(clientName, true);
        /** @type {number} */
        var loc = com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(clientName, com.inq.flash.messagingframework.StringUtils.htmlDecode(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA)),com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER,-1,
            null, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
        this.sendChatCommunicationMessage(message, loc);
    }

};

/**
 * Initiating the call message to agent
 */
com.inq.flash.client.control.ApplicationController.prototype.processClickToWebCallQueueMessages = function (chatParams) {
	var isVidyoEnabled = com.inq.utils.Util.getConfig("isVidyo", true);
	var vidyoKeyID = com.inq.utils.Util.getConfig("appKeyId", "123");
	this.callStreamData = "^^" + com.inq.flash.client.chatskins.SkinControl.CSDL_WEBCALLADDRESS + (isVidyoEnabled ? "true" : "false") + " " + !com.inq.flash.client.control.WebRTCMgr.isAudioOnlyWebCall();
	this.callStreamData += " " + com.inq.flash.client.control.FlashPeer.getVanityUrl()+ " "+vidyoKeyID;
	var message = new com.inq.flash.client.data.CallCommunicationMessage(this.chat, com.inq.flash.client.control.XFrameWorker.DO_NOT_DISPLAY_IN_CI + com.inq.utils.Util.getConfig("webCallStart", "Start call"));
	var loc  = -1;
	if(chatParams) {
		this.setEngageParameters(chatParams);
		if (chatParams["phone"]) {
			this.addInitialData(message, "CallerPhone", chatParams["phone"], "CallerPhone");
		}
		if(chatParams["clientOutcome"]) {
			loc = this.addClientOutcomeToChatWindow(chatParams["clientOutcome"]);
		}
	}
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CALL_ENABLED, "false");
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, loc);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME, com.inq.flash.client.control.FlashVars.getCustomerName());
	this.queueMessages = true;
	this.chatRouterListen = false;
	com.inq.flash.client.control.FlashVars.setCustomerName(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME), true);
	this.sendChatCommunicationMessage(message, loc);
};
/**
 * getMessageQueue
 * Getter - get messageQueue
 * This must be published so that it can be accessed via the presistent chat
 *
 * $type TFun([],TInst(Array,[TDynamic(null)]))
 * public function getMessageQueue()
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {Array}
 */
com.inq.flash.client.control.ApplicationController.prototype.getMessageQueue = function() {
	return this.messageQueue;
};


/**
 * getOpenerMessageQueue
 * Getter - get openerMessageQueue
 * This must be published so that it can be accessed via the presistent chat
 *
 * $type TFun([],TInst(Array,[TDynamic(null)]))
 * public function getOpenerMessageQueue()
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {Array}
 */
com.inq.flash.client.control.ApplicationController.prototype.getOpenerMessageQueue = function() {
	return this.openerMessageQueue;
};

/**
 * Send opener from opener queue to messages queue or just send opener if queueMessages false.
 */
com.inq.flash.client.control.ApplicationController.prototype.sendOpenerQueue = function() {
	while (this.openerMessageQueue.length > 0) {
		/** @type {Object} */
		var message = this.openerMessageQueue.shift();
		this.sendMessageOrQueue(message["msg"], message["clientTime"])
	}
};

/**
 * sendQueueingText
 *
 * $type TFun([{ name => queueingText, t => TInst(String,[]), opt => false },{ name => position, t => TInst(Int,[]), opt => false },{ name => agentAlias, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function sendQueueingText(queueingText:String, position:Int, agentAlias):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  queueingText
 * @param {number}  position
 * @param {string}  agentAlias
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendQueueingText = function(queueingText,position,agentAlias) {
	/** @type {com.inq.flash.client.data.ChatCommunicationQueueMessage} */
	var message = new com.inq.flash.client.data.ChatCommunicationQueueMessage(this.chat,queueingText,agentAlias);
	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR,"" + position);
	this.sendMessageOrQueue(message);
};


/**
 * enqueueOpenerText
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false },{ name => alias, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function enqueueOpenerText(text:String, alias:String):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  text
 * @param {string}  alias
 * @param {number}  sequenceNumber
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.enqueueOpenerText = function (text, alias, sequenceNumber) {
	/** @type {number} */
	var now = new Date().getTime();
	/** @type {com.inq.flash.client.data.ChatCommunicationOpenerMessage} */
	var message = new com.inq.flash.client.data.ChatCommunicationOpenerMessage(this.chat, text, alias, sequenceNumber);
	this.openerMessageQueue.push({"clientTime": now, "msg": message});
};


/**
 * sendText
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.client.data.ChatCommunicationMessage,[]), opt => false }],TEnum(Void,[]))
 * public function sendText(message:ChatCommunicationMessage):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.client.data.ChatCommunicationMessage}  message
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendText = function(message) {
	if (!this.firstMessageSent) {
		this.sendOpenerQueue();
	}

	this.sendMessageOrQueue(message);
	this.chatRouterListen = false;
	this.firstMessageSent = true;
};

/**
 * Sends the given message to the Agent.
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendTextToAgent = function (text) {
	haxe.Log.trace("enter", {
		fileName: "ApplicationController.hx",
		lineNumber: 618,
		className: "com.inq.flash.client.control.ApplicationController",
		methodName: "sendTextToAgent"
	});

	if (text == null || text == "") {
		haxe.Log.trace("no text", {
			fileName: "ApplicationController.hx",
			lineNumber: 670,
			className: "com.inq.flash.client.control.ApplicationController",
			methodName: "sendTextToAgent"
		});
		return;
	}

	haxe.Log.trace("Check connections", {
		fileName: "ApplicationController.hx",
		lineNumber: 637,
		className: "com.inq.flash.client.control.ApplicationController",
		methodName: "sendTextToAgent"
	});
	haxe.Log.trace("attemptingConnection=" + Std.string(this.attemptingConnection) + "\n" + "intentionalDisconnect=" + Std.string(this.intentionalDisconnect) + "\n", {
		fileName: "ApplicationController.hx",
		lineNumber: 643,
		className: "com.inq.flash.client.control.ApplicationController",
		methodName: "sendTextToAgent"
	});

	/** @type {number} */
	var loc = this.appendSentText(text, -1);
	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat, text);
	this.sendChatCommunicationMessage(message, loc);
};

/**
 * sendRestoredMessage
 *
 * $type TFun([],TEnum(Void,[]))
 * public function sendRestoredMessage():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendRestoredMessage = function() {
	if(com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) > 0) {
		if (com.inq.flash.client.control.ApplicationController.isSkipRestoreMsgOnce === true) {
			// if true skip sending Restore message once
			com.inq.flash.client.control.ApplicationController.isSkipRestoreMsgOnce = false;
		} else {
			/** @type {com.inq.flash.client.data.ChatActivityMessage} */
			var message = new com.inq.flash.client.data.ChatActivityMessage(this.chat,com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_RESTORED);
			this.sendMessageOrQueue(message);
		}
	}
};


/**
 * sendMinimizedMessage
 *
 * $type TFun([],TEnum(Void,[]))
 * public function sendMinimizedMessage():Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.sendMinimizedMessage = function() {
	if(com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) > 0) {
		/** @type {com.inq.flash.client.data.ChatActivityMessage} */
		var message = new com.inq.flash.client.data.ChatActivityMessage(this.chat,com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_MINIMIZED);
		this.sendMessageOrQueue(message);
	}
};


/**
 * TypingActivity
 *
 * $type TFun([{ name => bTyping, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public function TypingActivity(bTyping:Bool):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {boolean}  bTyping
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.TypingActivity = function(bTyping) {
	/** @type {number} */
	var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	if (this.firstMessageSent || msgcnt > 0) {
		/** @type {com.inq.ui.TextInput} */
		var txtInput = Application.application.getTextInput("txtInput");
		/** @type {string} */
		var text = txtInput._getInput();
        var message = bTyping ? new com.inq.flash.client.data.ChatActivityMessage(this.chat, com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_TYPING, null, null)
            : new com.inq.flash.client.data.ChatActivityMessage(this.chat, com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_STOPS_TYPING, text, null);
		this.sendMessageOrQueue(message);
	} else {
		this.skinControl.setTypingActivity(false);
	}
};


/**
 * appendSentText
 * Appends text to chat text area.
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false },{ name => position, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * public function appendSentText(text:String, position:Int ):Int
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  text
 * @param {number}  position - line number in transcript, "-1" means adding to the end of transcript
 * @param {Date=}  messageTimestamp
 * @return {number}
 */
com.inq.flash.client.control.ApplicationController.prototype.appendSentText = function(text,position, messageTimestamp) {
	return com.inq.flash.client.chatskins.SkinControl.AddCustomerTextToChatWindow(text,position, null, "", messageTimestamp);
};


/**
 * appendReceivedText
 *
 * public function appendReceivedText(text:String, sender:String, position:Int):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {string}  text
 * @param {string}  sender
 * @param {number}  position
 * @param {boolean} isAgentMessage - true if message from LiveAgent or VirtualAgent
 * @param {Array} expressionList
 * @param {string} restoreMode
 * @param {String} css - CSS name which can be appended in the Chat window.
 * @param {Date=}  messageTimestamp
 * @param {boolean=} isSurveyMessage - true if message is survey.
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.appendReceivedText = function (text, sender, position, isAgentMessage, expressionList, restoreMode, css, messageTimestamp, isSurveyMessage) {
	if (!com.inq.flash.client.control.XFrameWorker.isDisplayInCI(text)) {
		haxe.Log.trace("Text filtered... \"" + text + "\"", {
			fileName: "ApplicationController.hx",
			lineNumber: 167,
			className: "com.inq.flash.client.control.ApplicationController",
			methodName: "appendReceivedText"
		});
		return;
		/*  We don't display any messages with this token in the body of the text... MAINT27-580*/
	}
	var isFormStatus = text.indexOf(com.inq.utils.Util.getConfig("sFormSubmitted", "form submitted")) !== -1;
	if (isSurveyMessage) {
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(sender, text, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_INFO, position, expressionList, restoreMode, css, messageTimestamp);
	} else if (com.inq.flash.client.control.FlashVars.getCustomerName() == sender && !isAgentMessage) {
		com.inq.flash.client.chatskins.SkinControl.AddCustomerTextToChatWindow(text, position, expressionList, restoreMode, messageTimestamp);
	} else if (sender === "") {
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(sender, text, isFormStatus ? com.inq.flash.client.chatskins.ChatTextArea.FORM_STATUS : com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS, position, expressionList, restoreMode, css);
	} else if (com.inq.flash.client.control.FlashPeer.getIsBuilder() && sender == "system") {// enables mocking system message
		this.skinControl.AddTranscriptItemToChatWindow(sender, text, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, position, expressionList, restoreMode);
	} else {
		this.skinControl.AddTranscriptItemToChatWindow(sender, text, com.inq.flash.client.chatskins.ChatTextArea.AGENT, position, expressionList, restoreMode, css, messageTimestamp);
	}
};

/**
 * registerHandler
 *
 * $type TFun([{ name => handler, t => TInst(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,[]), opt => false }],TEnum(Void,[]))
 * private function registerHandler(handler: ClientApplicationMessageHandler):Void
 * @private
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler}  handler
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.registerHandler = function(handler) {
	this.framework.registerMessageHandler(handler);
	handler.setController(this);
};

/**
 * Check if during chat initialization it was detected that adblock(or similar)
 * was enabled in client's browser and, if so, disable user input in web chat window.
 *
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.checkIfAdBlockersActive = function() {
	if (com.inq.flash.client.control.FlashPeer.isAdblockEnabled()) {
		if (com.inq.utils.Util.getConfig(Application.application.notificationController.FLAG_ADBLOCK_DETECTION_ENABLED, false)) {
			com.inq.flash.client.chatskins.SkinControl.disableInput();
			com.inq.flash.client.chatskins.SkinControl.stopOpenerScript(true);
			com.inq.flash.client.chatskins.SkinControl.hideInput();
			com.inq.flash.client.chatskins.SkinControl.getSendButton().disable();
			Application.application.notificationController.showAdblockDetectedMessage();
		}
	}
};


/**
 * processMessage
 *
 * $type TFun([{ name => handler, t => TInst(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,[]), opt => false }],TEnum(Void,[]))
 * public function processMessage(message:Message):Void
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.ApplicationController.prototype.processMessage = function(message) {
    this.framework.processMessage(message);
};

/**
 * getMessagingFramework
 *
 * public function getMessagingFramework():FlashMessagingFramework
 * @public
 * @this com.inq.flash.client.control.ApplicationController
 * @return {com.inq.flash.messagingframework.FlashMessagingFramework}
 */
com.inq.flash.client.control.ApplicationController.prototype.getMessagingFramework = function() {
	return this.framework;
};

/**
 * Checks agent ID in the chat data and returns "true" if agent ID is exist.
 * @returns {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isAgentAssigned = function() {
	return !!com.inq.flash.client.control.FlashPeer.getAgentID();
};

/**
 * Set the flag when chat receives the message type "queue".
 * And set this back when agent assigned.
 * @param {boolean} v
 */
com.inq.flash.client.control.ApplicationController.prototype.setFlagChatInQueue = function(v) {
	this.flagChatInQueue = v;
};

/**
 * Returns the flag of state the chat accordingly the activity of queue messages.
 * @returns {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isChatInQueue = function() {
	return this.flagChatInQueue;
};

/**
 * Set the flag of username update.
 */
com.inq.flash.client.control.ApplicationController.prototype.updateUsername = function() {
	this._updateUsername = true;
};

/**
 * Cancel the flag of username update.
 */
com.inq.flash.client.control.ApplicationController.prototype.cancelUpdateUsername = function() {
	this._updateUsername = false;
};

/**
 * Checks and returns the true if need to update the username.
 * @returns {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isUpdateUsername = function() {
	/** @type {?string} */
	var customerDisplayName = com.inq.flash.client.control.FlashVars.getCustomerDisplayName();
	return this._updateUsername && !!customerDisplayName;
};

/**
 * Sends system message to AI and/or CI depending on the specified context.  If context is not specified, the message
 * will be sent to both AI and CI. This method provides support for ACIF and is called from CustomerAPI class.
 * @see RTDEV-17612 for details.
 * @see RTDEV-19128 for enhancement that add context parameter.
 * @see RTDEV-20426, reworks the 2 previous tickets.
 */
com.inq.flash.client.control.ApplicationController.prototype.sendSystemMessage = function(text, cssClass, context) {
	var position = "-1"; // position in chat transcripts
	if (!context || context === "customerInterface") {
		position = com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("", text, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, -1, null, null, cssClass);
	}

	var message = new com.inq.flash.client.data.ChatCommunicationSystemMessage(this.chat, text, "" + position, context, cssClass);
	this.sendMessageOrQueue(message);
};

com.inq.flash.client.control.ApplicationController.prototype.onLostConnection = function() {
	this.skinControl.connectionLostClosingChat(true);
};

com.inq.flash.client.control.ApplicationController.prototype.noUnload = function() {
	this.skinControl.noUnload();
};

com.inq.flash.client.control.ApplicationController.prototype.showIntroductionAfterPreloadMessages = function() {
	this.skinControl.showIntroductionAfterPreloadMessages();
};

com.inq.flash.client.control.ApplicationController.prototype.getMessageHandlerByPrefix = function(messageType) {
	return this.framework.getMessageHandlerByPrefix(messageType)
};

/**
 * Cleans up the {com.inq.flash.client.control.ApplicationController}'s static variables after a chat close.
 * @public
 * @static
 * @returns {void}
 */
com.inq.flash.client.control.ApplicationController.cleanUp = function() {
	com.inq.flash.client.control.ApplicationController.applicationController = null;
};

/**
 * Returns true if the number of next requesting message more than 1, for example when customer send first message
 * from chat opened in current tab, before he engaged chat in one of other tabs (for example such behavior implemented
 * in mobile browsers and embedded chats). See more information in the ticket RTDEV-27484.
 * @return {boolean}
 */
com.inq.flash.client.control.ApplicationController.prototype.isChatContinued = function() {
	return com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0) > 1;
};

/**
 * Adds property "time.delta" to message
 * @param {Object} msgItem
 *        {number} msgItem.clientTime the time of message creation
 *        {com.inq.flash.messagingframework.Message} msgItem.msg
 * @return {com.inq.flash.messagingframework.Message}
 */
com.inq.flash.client.control.ApplicationController.prototype.addTimeDeltaToMessage = function(msgItem) {
	/** @type {number} */
	var msgTime = msgItem["clientTime"];
	/** @type {number} */
	var deltaTime = Math.round(new Date().getTime() - msgTime);
	/** @type {com.inq.flash.messagingframework.Message} */
	var msg = msgItem["msg"];
	msg.addProperty(com.inq.flash.client.data.MessageFields.KEY_TIME_DELTA,"" + deltaTime);
	return msg;
};

/**
 * Sets chat id
 * @param {string} chatID
 */
com.inq.flash.client.control.ApplicationController.prototype.setChatID = function(chatID) {
	com.inq.flash.client.control.FlashVars.setValue("chatID", chatID);
	this.getChat().setChatID(chatID);
	this.updateMessageQueue(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID, chatID);
};

/**
 * Sets customer id to chat and messaging framework
 * @param {string} customerID
 */
com.inq.flash.client.control.ApplicationController.prototype.setCustomerID = function(customerID) {
	com.inq.flash.client.control.FlashVars.setValue("customerID", customerID);
	this.getChat().setCustomerID(customerID);
	this.updateMessageQueue(com.inq.flash.client.data.MessageFields.KEY_CUSTOMER_ID, customerID);
};

/**
 * Updates all messages in queue
 * @param {string} name
 * @param {string} value - new value for message field
 */
com.inq.flash.client.control.ApplicationController.prototype.updateMessageQueue = function (name, value) {
	var msgQueue = this.getMessageQueue();
	for (var i = 0; i < msgQueue.length; i++) {
		msgQueue[i].msg.setPropertyIfNotNullIfExists(name, value);
	}
};

/** @private @type {number} */
com.inq.flash.client.control.ApplicationController.prototype.sendButtonClickedTime = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.bSendClickStreamData = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.chatAccepted = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.authorizedOnce = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.waitingToExitChat = null;
/** @private @type {Array} */
com.inq.flash.client.control.ApplicationController.prototype.openerMessageQueue = null;
/** @private @type {Array} */
com.inq.flash.client.control.ApplicationController.prototype.messageQueue = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.chatRouterListen = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.notifiedAsPersistent = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.attemptingConnection = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.wasConnected = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.persistentReconnect = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.queueMessages = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.intentionalDisconnect = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.firstMessageSent = null;
/** @private @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.builtApplicationParameters = null;
/** @private @type {com.inq.flash.messagingframework.FlashMessagingFramework} */
com.inq.flash.client.control.ApplicationController.prototype.framework = null;
/** @private @type {string} */
com.inq.flash.client.control.ApplicationController.prototype.agentID = null;
/** @private @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.control.ApplicationController.prototype.chat = null;
/** @private @type {string} */
com.inq.flash.client.control.ApplicationController.prototype.callStreamData = null;
/** @type {com.inq.flash.client.control.ApplicationController} */
com.inq.flash.client.control.ApplicationController.prototype.__class__ = com.inq.flash.client.control.ApplicationController;
/** @type {com.inq.flash.client.control.ApplicationController} */
com.inq.flash.client.control.ApplicationController.applicationController = null;
/** @type {number} */
com.inq.flash.client.control.ApplicationController.prototype.msgcntAtEntry = 0;
/** @type {boolean} */
com.inq.flash.client.control.ApplicationController.prototype.clientDisconnect = false;
